import styles from './styles.module.css';
import AddNewIcon from '@/assets/icons/AddNew.svg?react';

function PlusButton({
  onClick,
  label
}: {
  onClick: () => void;
  label: string;
}) {
  return (
    <div
      id={`${label}-plus-button`}
      className={styles.plusButtonContainer}
      onClick={onClick}
    >
      {label && <span>{label}</span>}
      <AddNewIcon style={{ width: '24px', height: '24px' }} />
    </div>
  );
}

export default PlusButton;
